import type { FunctionComponent } from 'react';
import type { IClientUser } from '../interfaces/user';
import React, { useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import MessageContent from '../components/Messages/MessageContent';
import TabbedMessageUserList from '../components/Messages/TabbedMessageUserList';
import MessageUserSearch from '../components/Messages/MessageUserSearch';
import Navigation from '../components/Navigation';
import { MessageContextProvider } from '../contexts/messageContext';
import TabbedRoomListsContextProvider from '../contexts/tabbedRoomListsContext';
import { ReactComponent as BackIcon } from '../assets/svg/back.svg';
import { getCompressedImagePath } from '../utils/getCompressedImagePath';

import { useBreakpoint } from '../hooks/useBreakpoint';

const MessagesPage: FunctionComponent<IClientUser> = (props) => {
  const [openRoom, setOpenRoom] = useState(false);
  const [currentChatUser, setCurrentChatUser] = useState<any>(null); // Add state for user
  const [currentRoomType, setCurrentRoomType] = useState<string | null>(null);
  const { path } = useRouteMatch();
  const currBreakPoint = useBreakpoint();

  const mobileBreakpoint = currBreakPoint === 'sm' && openRoom;

  // Include desktop & tablet screen size
  const desktopBreakpoint = currBreakPoint === 'md' || currBreakPoint === 'lg';

  return (
    <main className="page-messages">
      <Navigation {...props} />
      <MessageContextProvider currentUser={props.user!}>
        <TabbedRoomListsContextProvider>
          <section className="container">
            <div
              className={`columns is-gapless p-r-0 p-l-0 ${
                !mobileBreakpoint && 'section'
              }`}
            >
              {mobileBreakpoint && (
                <div className="column is-hidden-desktop is-hidden-tablet">
                  <div className="back-button-header is-flex">
                    <div
                      className="back-button-mobile p-l-1 is-flex"
                      onClick={() => setOpenRoom(!openRoom)}
                    >
                      <BackIcon />
                    </div>
                    <div className="back-button-title-wrapper is-flex">
                      {currentChatUser?.profile?.name && (
                        <span className="back-button-title has-text-weight-semibold">
                          {currentChatUser.profile.name}
                        </span>
                      )}
                      {currentChatUser?.chatType === 'coffee' && (
                        <span className="coffee-chat-badge">Coffee Chat</span>
                      )}
                    </div>
                    {currentChatUser?.avatar?.fileUrl && (
                      <div className="back-button-right is-flex">
                        <img
                          src={getCompressedImagePath(currentChatUser.avatar.fileUrl, 'thumbnail') || currentChatUser.avatar.fileUrl}
                          alt="profile"
                          className="image is-inline is-rounded-circle"
                        />
                        <button className="back-button-menu">
                          <span>⋮</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="column page-messages-column page-messages-column-list is-one-quarter">
                <div id="scrollableDiv"
                  className={`card page-messages-column-list-card is-dropshadowed is-paddingless ${
                    mobileBreakpoint && 'is-hidden'
                    }`}
                >
                  <div className="card-content page-messages-column-list-card-content is-paddingless">
                    <div className="p-t-1 p-r-1 p-b-1 p-l-1">
                      <MessageUserSearch />
                    </div>
                    <ul>
                      <TabbedMessageUserList setOpenRoom={setOpenRoom} />
                    </ul>
                  </div>
                </div>
              </div>
              {(mobileBreakpoint || desktopBreakpoint) && (
                <div className="column page-messages-column page-messages-column-content">
                  <div className={`card page-messages-column-content-card is-rounded ${currentRoomType === 'coffee' ? 'is-coffee-chat' : ''
                    }`}>
                    <Switch>
                      <Route
                        path={`${path}/:roomId`}
                        render={(routeProps) => (
                          <MessageContent
                            {...routeProps}
                            onUserLoaded={setCurrentChatUser}
                            onRoomLoaded={setCurrentRoomType}
                          />
                        )}
                      />
                    </Switch>
                  </div>
                </div>
              )}
            </div>
          </section>
        </TabbedRoomListsContextProvider>
      </MessageContextProvider>
    </main>
  );
};

export default MessagesPage;
